<template>
  <div class="mb-5" v-if="data">
    <div class="btn-group">
      <button
        class="btn btn-sm btn-circle-xl btn-outline-info"
        title="Back"
        aria-label="Terug"
        @click="$router.push({ name: 'geboortelijst' })"
      >
        <i class="icon fas fa-arrow-left"></i>
      </button>
      <button
        class="btn btn-sm btn-outline-primary"
        @click="deleteArtikel"
        v-if="currentUser && currentUser.email"
      >
        Verwijderen
      </button>
      <button
        class="btn btn-sm btn-outline-primary"
        aria-label="Buy"
        @click="$router.replace('/edit/' + id)"
        v-if="currentUser && currentUser.email"
      >
        Aanpassen
      </button>
    </div>
    <h1 class="">
      {{ data.naam }}
    </h1>
    <p>{{ data.naam_detail }}</p>
    <p class="lead">{{ data.description }}</p>

    <h4>
      <template>€ {{ data.prijs_donated }}</template>
      <small>/ € {{ data.prijs }} gegeven</small>
    </h4>

    <div class="mb-4 mt-4">
      <!-- Button trigger modal -->
      <button
        type="button"
        class="btn btn-outline-info"
        data-toggle="modal"
        data-target="#exampleModal"
        title="Bijleggen"
        aria-label="Buy"
        v-if="remaining > 0"
      >
        Ik wil bijleggen!
      </button>
      <button v-else disabled="disabled" class="btn btn-outline-success">
        Het hele bedrag werd al gegeven!
      </button>
    </div>

    <div class="mt-3 clearfix">
      <vue-glide
        v-if="data.carousel.length > 1"
        :bullet="true"
        focusAt="center"
        :startAt="0"
        :perView="2"
        :breakpoints="{ 800: { perView: 1 }, 1200: { perView: 3 } }"
        type="carousel"
      >
        <vue-glide-slide
          v-for="(img, idx) in data.carousel"
          class="align-self-center"
          :key="'img_' + idx"
        >
          <img :src="img" alt class="img-fluid" />
        </vue-glide-slide>
        <template slot="control">
          <button data-glide-dir="<"><</button>
          <button data-glide-dir=">">></button>
        </template>
      </vue-glide>
      <div class="text-center" v-else-if="data.carousel.length == 0">
        <img :src="data.carousel[0]" alt class="img-fluid" />
      </div>
      <div class="text-center" v-else>
        <img alt="" :src="data.img" class="img-fluid" />
      </div>
    </div>

    <!-- Modal for bijleggen -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h5 class="modal-title mb-4" id="exampleModalLabel">
              Bijleggen aan {{ data.naam }}
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h5>
            <p class="card-text">
              Bedankt dat je wil bijleggen!
              <template v-if="config.show_gift_suggestions"
                >Hoeveel had je graag gegeven?</template
              >
            </p>

            <div
              class="list-group"
              v-if="!isEmpty(selectedValue) && config.show_gift_suggestions"
            >
              <template v-for="val in selectedValue">
                <a
                  href="#"
                  @click.prevent="value = val"
                  :class="{ active: value == val }"
                  :key="val"
                  class="list-group-item list-group-item-action"
                  v-if="val != 'remaining'"
                  >€{{ val }}</a
                >
                <a
                  href="#"
                  @click.prevent="value = remaining"
                  class="list-group-item list-group-item-action"
                  :class="{ active: value == remaining }"
                  :key="val"
                  v-else
                  >€{{ remaining }}</a
                >
              </template>
            </div>
            <p v-else-if="isEmpty(selectedValue)">
              Het volledige bedrag is al gegeven! Toch nog bijdragen?
            </p>
            <div class="form-group mt-3 mb-3">
              <label for="value">Kies zelf het bedrag</label>
              <input
                id="value"
                type="number"
                min="0"
                v-model="value"
                class="form-control"
                placeholder="30"
              />
            </div>

            <button
              class="btn btn-primary mt-2 mr-2 float-right"
              :disabled="value == 0"
              @click="confirm"
              data-dismiss="modal"
            >
              Maak reservering!
            </button>
            <button
              class="btn btn-primary mt-2 mr-2 float-right"
              data-dismiss="modal"
            >
              Annuleer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Glide, GlideSlide } from "vue-glide-js";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      data: { carousel: [], prijs_donated: 0, prijs: 0 },
      buy: false,
      value: 0,
      doc: undefined,
      selectedImg: undefined,
      values: [
        {
          min: -Infinity,
          max: 0,
          values: [],
        },
        {
          min: 0,
          max: 40,
          values: ["remaining"],
        },
        {
          min: 40,
          max: 100,
          values: [15, 25, 40, 50],
        },
        {
          min: 100,
          max: Infinity,
          values: [25, 40, 50, 75],
        },
      ],
    };
  },
  props: ["id"],
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  computed: {
    ...mapState(["currentUser", "counter", "config"]),
    remaining() {
      return this.data.prijs - this.data.prijs_donated;
    },
    selectedValue() {
      return this.$_.find(this.values, (x) => {
        return x.min <= this.remaining && x.max > this.remaining;
      }).values;
    },
  },
  methods: {
    ...mapActions(["makeReservation"]),
    ...mapMutations(["increase"]),
    isEmpty(val) {
      return this.$_.isEmpty(val);
    },
    isArray(val) {
      return this.$_.isArray(val);
    },
    deleteArtikel() {
      this.$alertify.confirm("Wil je echt verwijderen?", () => {
        this.$firebase
          .firestore()
          .collection("artikels")
          .doc(this.id)
          .delete()
          .then(() => {
            this.$router.push({ name: "geboortelijst" });
          });
      });
    },
    back() {
      this.increase();
      this.$ga.event({
        eventCategory: "terug",
        eventAction: "increase",
        eventValue: this.counter,
      });
      this.$router.go(-1);
    },
    confirm() {
      this.makeReservation({
        artikel: this.data,
        id: this.id,
        // doc: this.doc,
        value: this.value,
      })
        .then((res) => {
          this.$router.push({ name: "checkout" });
        })
        .catch((err) => {
          this.$alertify.error("Oepsie, er ging iets mis!");
        });
    },
  },
  created() {
    this.doc = this.$firebase.firestore().collection("artikels").doc(this.id);
    this.doc.onSnapshot(
      (doc) => {
        this.data = doc.data();
        this.$ga.page({
          page: this.$route.currentRoute,
          title: this.data.naam,
          location: window.location.href,
        });
      },
      (err) => {
        this.$alertify.error(err);
      }
    );
  },
};
</script>

<style>
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}
.btn-circle.btn-lg {
  width: 50px;
  height: 50px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 25px;
}
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  font-size: 24px;
  line-height: 1.33;
  border-radius: 35px;
}
</style>

